<app-toast></app-toast>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.settings' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.company_information' | transloco }}" [isActive]="true"
                    link="/settings/company"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.my_profile' | transloco }}"
                    link="/settings/profile"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.team' | transloco }}" link="/settings/team"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.billing' | transloco }}"
                    link="/settings/billing"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.plans' | transloco }}"
                    link="/settings/plans"></app-tab-button>
            </div>

            <!-- User Banner -->
            <app-user-banner [editing]="isUserEditing" (editButtonClick)="editSaveButtonClick()"></app-user-banner>

            <!-- Company Information -->
            <div
                class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] h-auto border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">
                <!-- Header text -->
                <div class="flex">
                    <div class="flex flex-col gap-4 h-[60px] justify-between">
                        <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                            'shared.company_information'
                            | transloco }}
                        </p>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
                <!-- Content -->
                <div class="m-4 flex flex-col">
                    <div class="w-full flex flex-wrap gap-5">
                        <div class="max-w-screen-sm flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.company.company_name' | transloco }}"
                                [inputId]="'companyName'" [inputType]="'text'" [(inputValue)]="companyNameInput"
                                [errorMessage]="companyNameInputError"
                                placeholder="{{ 'shared.placeholders.company.company_name' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <div class="max-w-screen-sm flex-[1] min-w-[300px] self-end mobile:w-full">
                            <app-custom-autocomplete labelText="{{ 'auth.ateco_code' | transloco }}"
                                placeholder="{{ 'auth.select_ateco_code' | transloco }}" [suggestions]="allAtecoCodes"
                                [errorMessage]="industryCodeInputError" [labelRenderer]="labelRendererFn"
                                [(selectedItem)]="selectedAtecoCode"
                                [isDisabled]="(!atecoCodesLoaded || editingInputDisabled)"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabledTitle]="clickEditTitle">
                            </app-custom-autocomplete>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>